import { ProfileConfigService } from '@openeducation/oe-it-services';
import type { ProfileConfigDto } from '@openeducation/oe-it-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export const useGetProfileConfig = () => {
  const { environment } = useEnvironmentContext();

  return useQuery<ProfileConfigDto>('profileConfig', () =>
    ProfileConfigService.getProfileConfig(environment)
  );
};
